import KformComponent from '../kform-component';

export default class FileCurrentComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentFileCurrent | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.disabled = settings?.disabled ?? false;
		this.input = false;
	}
}
